import { range } from 'lodash-es'

export default function Stars({ score, className }) {
  return (
    <div className='flex'>
      {
        range(5).map(index => {
          const color = () => {
            if (index < Math.round(score)) return 'text-yellow-400'
            return 'text-gray-300'
          }
          return (
            <Icon.StarFilled
              key={ index }
              className={ cn(color(), className) }
            />
          )
        })
      }
    </div>
  )
}
